import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-192" data-mp="1wal2ajeithp2" />, document.getElementById('root'));